// Copyright 2026 Monterosa Productions Limited. All rights reserved.

// Runtime config injected by env-config.js (CDK synth) or public/env-config.js (local dev).
export const config = window.__PROXIMA_CONFIG__;
